import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/global.css";

function Notifications() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/auth/session`, { withCredentials: true })
      .then((res) => {
        if (res.data.user) {
          setUser(res.data.user);
        } else {
          navigate("/?error=Sessione Utente Inesistente");
        }
      })
      .catch(() => navigate("/?error=Sessione Utente Inesistente"));
  }, [navigate]);

  return (
    <main className="notifications_container">
      <div className="window">
        <h2>Notifiche</h2>
        <ul className="notification-list">
          <li className="notification-item">
            <img src="{`${process.env.PUBLIC_URL}/images/svg/info_icon.svg" alt="Info" className="notification-icon" />
            <div className="notification-description">
              <span>Il sistema è stato aggiornato con successo.</span>
            </div>
            <div className="notification-time">10/01/2025 14:30</div>
          </li>
          <li className="notification-item">
            <img src="{`${process.env.PUBLIC_URL}/images/svg/warning_icon.svg" alt="Avviso" className="notification-icon" />
            <div className="notification-description">
              <span>Controlla lo stato del camion AB123CD.</span>
            </div>
            <div className="notification-time">09/01/2025 10:15</div>
          </li>
          <li className="notification-item">
            <img src="{`${process.env.PUBLIC_URL}/images/svg/error_icon.svg" alt="Errore" className="notification-icon" />
            <div className="notification-description">
              <span>Errore nel caricamento dei dati. Riprovare.</span>
            </div>
            <div className="notification-time">08/01/2025 16:45</div>
          </li>
        </ul>
      </div>
    </main>
  );
}

export default Notifications;